module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/ebsDocuments-d39288f72476f6cfede274e318889a9a.png";